import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
export interface adpopupinterceptResponseData {
  /** 累计拦截次数 */
  total_intercept_count: number
  /** 所选时间段内拦截次数 */
  period_intercept_count: number
  /** 广告弹窗软件数量 */
  ad_popup_soft_count: number
  /** 涉及广告弹窗软件的终端数 */
  involved_terminal_count: number
}
export interface adpopupinterceptTrendStatRequestParams {
  /** 开始时间（时间戳，单位：秒） */
  start_time: string
  /** 结束时间（时间戳，单位：秒） */
  end_time: string
  /** 统计粒度："hour" 或 "day" */
  granularity: string
}

export interface adpopupinterceptTrendStatResponseData {
  /** 时间标签数组（秒级时间戳） */
  timestamps: string[]
  /** 拦截次数数组 */
  intercept_counts: number[]
}
export interface adpopupinterceptTopSoftStatRequestParams {
  /** 开始时间（时间戳，单位：秒） */
  start_time: string
  /** 结束时间（时间戳，单位：秒） */
  end_time: string
}

export interface TopSoftList {
  /** 软件名称 */
  soft_name: string
  /** 拦截次数 */
  intercept_count: number
}

export interface adpopupinterceptTopSoftStatResponseData {
  /** TOP5广告弹窗拦截软件列表 */
  top_soft_list: TopSoftList[]
}

@Injectable()
export class PopupInterceptService {
  constructor (private http: Http) {}

  // 广告弹窗拦截统计接口
  getAdpopupinterceptOverviewStat () {
    return this.http.post<adpopupinterceptResponseData>('/adpopupintercept/overview-stat', {})
  }
  // 广告弹窗拦截趋势接口
  getAdpopupinterceptTrendStat (data: adpopupinterceptTrendStatRequestParams) {
    return this.http.post<adpopupinterceptTrendStatResponseData>('/adpopupintercept/trend-stat', data)
  }
  // 广告弹窗TOP软件统计接口
  getAdpopupinterceptTopSoftStat (data: adpopupinterceptTopSoftStatRequestParams) {
    return this.http.post<adpopupinterceptTopSoftStatResponseData>('/adpopupintercept/top-soft-stat', data)
  }
}
